// src/components/HomePage/FaqSection.jsx
import React, { useState } from "react";
import { AiOutlinePlus, AiOutlineClose } from "react-icons/ai";
import Fade from "react-reveal/Fade";

const faqData = [
  {
    question: "Pourquoi une consultation avant la Hijama ?",
    reponse:
      "Parce qu'une séance de Hijama ne doit pas être proposée automatiquement. L'échange préalable permet de comprendre votre demande, de connaître les précautions utiles et de déterminer si cette pratique est adaptée à votre situation.",
  },
  {
    question: "Est-ce que la Hijama est réalisée dès le premier rendez-vous ?",
    reponse:
      "Pas nécessairement. La première étape consiste à écouter et à comprendre. Une séance peut être proposée uniquement si elle est jugée appropriée après l'échange préalable.",
  },
  {
    question: "Puis-je arrêter mon traitement médical ?",
    reponse:
      "Non. Fouta Bio ne recommande pas l'arrêt d'un médicament ou d'un suivi médical. Toute modification de traitement doit être discutée avec le professionnel de santé qui vous suit.",
  },
  {
    question: "Naturel signifie-t-il sans risque ?",
    reponse:
      "Non. Une plante ou un produit naturel peut présenter des contre-indications, des interactions ou des risques liés au dosage. Il est important de respecter les conseils d'utilisation et de signaler les traitements déjà suivis.",
  },
  {
    question: "Peut-on obtenir un diagnostic par WhatsApp ?",
    reponse:
      "Non. WhatsApp permet de poser une première question, de demander une information ou de prendre rendez-vous. Il ne remplace pas une consultation et aucun diagnostic ne doit être établi uniquement par message.",
  },
  {
    question: "Comment se déroule une première consultation ?",
    reponse:
      "Elle commence par un échange sur votre situation, vos attentes, vos habitudes et les suivis déjà en cours. Fouta Bio vous explique ensuite l'orientation envisageable, ses limites et les prochaines étapes.",
  },
  {
    question: "La Roqya proposée est-elle conforme aux principes islamiques ?",
    reponse:
      "Fouta Bio présente une Roqya fondée sur la récitation du Coran et les invocations authentiques, sans intimidation, sans promesse et sans mise en scène alarmiste.",
  },
  {
    question: "La Roqya remplace-t-elle un suivi médical ou psychologique ?",
    reponse:
      "Non. Elle peut s'inscrire dans la démarche spirituelle d'une personne, mais elle ne remplace pas l'évaluation ou le suivi d'un professionnel de santé lorsque cela est nécessaire.",
  },
  {
    question: "Comment les produits naturels sont-ils sélectionnés ?",
    reponse:
      "Ils sont choisis avec attention selon leur qualité, leur origine lorsqu'elle est connue, leur usage traditionnel et les informations disponibles sur leur utilisation.",
  },
  {
    question: "Puis-je acheter un produit sans consultation ?",
    reponse:
      "Cela dépend du produit. Certains peuvent être achetés directement avec leurs conseils d'utilisation. Pour d'autres, Fouta Bio peut recommander un échange préalable afin de vérifier les précautions nécessaires.",
  },
  {
    question: "Mes informations restent-elles confidentielles ?",
    reponse:
      "Oui. Les informations communiquées sont traitées avec discrétion et utilisées uniquement pour répondre à votre demande ou organiser votre accompagnement.",
  },
  {
    question: "Comment prendre rendez-vous ?",
    reponse:
      "Via le bouton « Prendre rendez-vous » du site, qui ouvre WhatsApp. Les horaires, l'adresse et les modalités de confirmation seront indiqués lors de votre prise de contact.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      {/* Header section - fond vert clair */}
      <section className="faq-header-section">
        <div className="container-faq">
          <Fade bottom>
            <p className="faq-eyebrow">FAQ</p>
            <h2 className="faq-title">Questions fréquentes</h2>
            <p className="faq-subtitle">
              Retrouvez les réponses aux questions les plus souvent posées sur
              nos accompagnements, nos produits et notre fonctionnement.
            </p>
          </Fade>
        </div>
      </section>

      {/* Accordéon - fond blanc */}
      <section className="faq-body-section">
        <div className="container-faq">
          <div className="faq-accordion">
            {faqData.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className={`faq-item ${isOpen ? "faq-item-open" : ""}`}
                >
                  <button
                    className="faq-question"
                    onClick={() => toggleFaq(index)}
                    aria-expanded={isOpen}
                  >
                    <span>{item.question}</span>
                    {isOpen ? (
                      <AiOutlineClose className="faq-icon" />
                    ) : (
                      <AiOutlinePlus className="faq-icon" />
                    )}
                  </button>
                  {isOpen && (
                    <div className="faq-reponse">
                      <p>{item.reponse}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="faq-disclaimer">
            <span className="faq-disclaimer-icon">ℹ️</span>
            <p>
              Les informations présentées sur ce site sont générales et ne
              remplacent pas une consultation médicale personnalisée. En cas
              de doute, consultez un professionnel de santé.
            </p>
          </div>
        </div>
      </section>

      {/* CTA WhatsApp - fond vert foncé */}
      <section className="faq-cta-section">
        <div className="container-faq text-center">
          <h3 className="faq-cta-title">
            Vous ne trouvez pas la réponse à votre question ?
          </h3>
          <p className="faq-cta-text">
            Posez-nous votre question directement sur WhatsApp.
            <br />
            Nous vous répondrons avec sérieux et sans engagement.
          </p>
          
         <a  href="https://wa.me/VOTRE_NUMERO"
            target="_blank"
            rel="noopener noreferrer"
            className="faq-cta-btn"
          >
            Écrire sur WhatsApp
          </a>
        </div>
      </section>
    </>
  );
};

export default Faq;